//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Post } from "@/models";
import TabNavNormal from '@/components/tab/TabNavNormal.vue'
import { SPECIAL_CHANNEL_ID } from "@/utils/constants"
import { setImmediate, setTimeout } from 'timers';
import CollectionPostPageItem from './post_child_page/CollectionPostPageItem'
import { Collection } from '@/models'

const map = [
  ['全部'],
  ['语音', SPECIAL_CHANNEL_ID.WORK_AUDIO],
  ['视频', SPECIAL_CHANNEL_ID.WORK_VIDEO],
  ['笔记', SPECIAL_CHANNEL_ID.WORK_NOTE],
  ['写字', SPECIAL_CHANNEL_ID.WORK_WRITING],
  ['音乐', SPECIAL_CHANNEL_ID.WORK_MUSIC],
  ['绘画', SPECIAL_CHANNEL_ID.WORK_PAINTING],
  ['配图', SPECIAL_CHANNEL_ID.WORK_PICTURE],
  ['随笔', SPECIAL_CHANNEL_ID.WORK_ESSAY]
]

export default {
  data () {
    return {
      indexType: 0,
      collectionId: '',
      collectionName: undefined,
      list: [
        '全部',
        '语音',
        '笔记',
        '写字',
        '音乐',
        '绘画',
        '配图',
        '随笔',
        '视频',
      ],
      map: map
    }
  },

  created () {
    this.collectionId = this.$route.params.collectionId
    this.collectionName = this.$route.params.collectionName

    if (!this.collectionName) {
      Collection.getById(this.collectionId).then(result => {
        this.collectionName = result.get('name')
      })
    }
  },

  methods: {
    clickBarItem (index) {
      this.indexType = index
    },

    changeTitle (collectionName) {
      this.collectionName = collectionName
    },

    // 用于子组件触发来更改title
    setTitle (title) {
      this.title = title
    }
  },

  components: {
    TabNavNormal,
    CollectionPostPageItem,
    Collection
  }
}



// WEBPACK FOOTER //
// ./src/pages/library/CollectionPost.vue